import * as React from "react"

type Props = {
    children: React.ReactNode
}

const UnauthorizedContentBox = (props: Props) => {
    return <div className={classes.box}>{props.children}</div>
}

const classes = {
    box: "mt-[56px] w-full items-center rounded-lg bg-white py-8 px-4 shadow md:py-12 md:px-10",
}

export default UnauthorizedContentBox
